import { render } from "./SwdSpinner.vue?vue&type=template&id=4bc3aa0e"
import script from "./SwdSpinner.vue?vue&type=script&lang=js"
export * from "./SwdSpinner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__